// Module
var code = `<h2 class="margin-bottom-xs margin-top-xs"><strong class="margin-right">3.</strong>Enter License Key</h2>
<form class="flex-form" data-bind="with: model.license, submit: save">
    <div class="row flex-row">
        <div class="col-sm-8">
            <div class="panel padding-md">
                <label for="inputLicenseKey" class="control-label">License <i class="required"></i></label>
                <div data-bind="validationElement: license">
                    
                    <div class="flex-grow">
                        <textarea rows="9" class="form-control" id="inputLicenseKey" data-bind="textInput: license" placeholder='e.g.
 {
             "Id": "12345678-1234-1234-1234-123456789101",
             "Name": "RavenDB License Owner",
             "Keys": [
                 "aBcDeFgHiJkLmNoPqRsTuVwXyZ",
                 "~!@#\$%^&*()_+=-0987654321\`"
             ]
 }'></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4 flex-vertical">
            <div class="panel panel-info padding-md flex-grow flex-vertical">
                <div>
                    <i class="icon-license icon-xl"></i>
                </div>
                <div class="text-center">
                    <p class="lead margin-bottom-sm">No license?</p>
                    <p class="small margin-bottom margin-lg">We have multiple license options available for you, including a FREE license suitable for production use.</p>
                </div>
                <div class="flex-separator"></div>
                <div class="flex-center">
                    <a class="btn btn-info" target="_blank" data-bind="attr: { 'href': \$root.licenseUrl }">Get license</a>
                </div>
            </div>
        </div>
    </div>
    <div class="navigation margin-top margin-bottom flex-horizontal">
        <a href="#security" class="btn btn-default"><i class="icon-arrow-left"></i><span>Back</span></a>
        <div class="flex-separator"></div>
        <button type="submit" class="btn btn-primary" data-bind="css: { 'btn-spinner': \$root.spinners.next }, disable: \$root.spinners.next">
            <span>Next</span> <i class="icon-arrow-right"></i>
        </button>
    </div>
</form>
`;
// Exports
export default code;